import styled from "styled-components";

import { MacroTemplateContainer } from "../../styles";

export const AnnouncementsTemplatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DesignContainer = styled(MacroTemplateContainer)`
  border-radius: 12px;
  overflow: hidden;
  padding: 24px 0px;
  cursor: pointer;

  & > div:first-child {
    width: 1000px;
    transform: translateX(24px);
  }
`;

export const OverviewAnnouncementsTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
`;

export const OverviewAnnouncementsTemplateContainer = styled.div`
  & > div {
    height: auto;
  }
`;

export const OverviewAnnouncementsMultipleTemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & > div {
    height: auto;
  }
`;

export const OverviewDesignContainer = styled.div`
  position: relative;
  border-radius: ${({ borderRadius = 13 }) => borderRadius}px;
  height: fit-content;
  cursor: pointer;
  height: 100%;

  ${({ isSelected }) =>
    isSelected &&
    `outline-offset: 3px;
    outline: 6px solid #00afff4d;`};

  ${({ hasHover, theme }) =>
    hasHover &&
    `
    &:hover {
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    }`};
`;
